import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/lib/auth";
import { BrandLogo } from "@/components/site/Header";
import { BookingsTab } from "@/components/admin/BookingsTab";
import { GiftsTab, MessagesTab, ReservationsTab } from "@/components/admin/ListTabs";
import { RetreatsTab } from "@/components/admin/RetreatsTab";
import { ScheduleTab } from "@/components/admin/ScheduleTab";
import { StoriesTab } from "@/components/admin/StoriesTab";
import { PrayerTab } from "@/components/admin/PrayerTab";
import { GuidesTab } from "@/components/admin/GuidesTab";
import { TeamTab } from "@/components/admin/TeamTab";

const TABS = [
  ["bookings", "Bookings", BookingsTab],
  ["prayer", "Prayer requests", PrayerTab],
  ["hours", "Coaching hours", ScheduleTab],
  ["messages", "Notes", MessagesTab],
  ["reservations", "Retreat sign-ups", ReservationsTab],
  ["retreats", "Manage retreats", RetreatsTab],
  ["stories", "Couples' stories", StoriesTab],
  ["guides", "Free guides", GuidesTab],
  ["gifts", "Gifts", GiftsTab],
  ["team", "Team & password", TeamTab],
];

export default function Admin() {
  const { user, logout } = useAuth();
  return (
    <div className="site min-h-screen bg-sage text-pine" data-testid="admin-page">
      <header className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center" data-testid="admin-site-link"><BrandLogo className="h-12" /></Link>
        <div className="flex items-center gap-4 text-sm">
          <span className="text-moss hidden sm:inline" data-testid="admin-user-email">{user.email}</span>
          <button type="button" onClick={logout} className="inline-flex items-center gap-2 rounded-full border border-pine px-4 py-2" data-testid="admin-logout-button"><LogOut size={14} /> Sign out</button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 pb-24">
        <p className="lb text-brass-ink mt-6">Private inbox</p>
        <h1 className="dp mt-3 !text-5xl">Welcome back, <em>{user.name || "friend"}</em></h1>
        <Tabs defaultValue="bookings" className="mt-10">
          <TabsList className="h-auto flex-wrap justify-start gap-1 bg-paper rounded-full p-1">
            {TABS.map(([v, label]) => (
              <TabsTrigger key={v} value={v} className="rounded-full px-5 py-2 data-[state=active]:bg-pine data-[state=active]:text-sage" data-testid={`admin-tab-${v}`}>{label}</TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(([v, , Comp]) => (
            <TabsContent key={v} value={v} className="mt-8"><Comp /></TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  );
}
